import { EtapaEnum } from '@conacyt/dms-client';

// Errors
export const PROBLEM_BASE_URL = 'https://www.jhipster.tech/problem';
export const EMAIL_ALREADY_USED_TYPE = `${PROBLEM_BASE_URL}/email-already-used`;
export const LOGIN_ALREADY_USED_TYPE = `${PROBLEM_BASE_URL}/login-already-used`;

export const MAXIMO_REGISTROS_PAGINACION_SACI = 300;
export const ETAPA: EtapaEnum = 'REGISTRO';
export const CARPETA = 'DADC';
export const RUTA_RELATIVA_CARTA = '/cartasConclusion';
